import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationService } from '@ciam/library';
import { QueryParamService } from '../../services/query-param/query-param.service';

/**
 * Intercept backend requests and add wiremock scenarios if current environment allows it
 */
@Injectable({
  providedIn: 'root'
})
export class MockCaseInterceptor implements HttpInterceptor {

  constructor(
    private configService: ConfigurationService,
    private queryParamService: QueryParamService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const mockMap = new Map();
    if(this.isMockAllowed) { //if mock overwrite is allowed
      this.queryParamService.getAll('wiremockCase').forEach((wiremockCase) => {
        try {
          const caseJson = JSON.parse(wiremockCase);
          mockMap.set(caseJson.targetApi, caseJson.case);
        }
        catch (e) {}
      });
      for(const entry of mockMap.entries()) {
        if(req.url.includes(entry[0])) {
          return next.handle(this.addWiremockCase(req, entry[1]));
        }
      }
    }
    return next.handle(req);
  }

  /**
   * Add wiremock case request params
   *
   * @param req
   * @param param
   */
  addWiremockCase(req: HttpRequest<any>, param: string): HttpRequest<any> {
    return req.clone({
      params: (req.params ? req.params : new HttpParams()).set('is_refactor', 'true').set('scenario', param)
    });
  }

  /**
   * Check and see if mocking is allowed.
   */
  get isMockAllowed(): boolean {
    if(this.queryParamService.get('mock') === 'true' ) {
      return true;
    }
    else if(this.configService.select<boolean>('env.mock')) { //DO NOT USE INTELLIJ SIMPLIFY HERE. This can return null/undefined
      return true;
    }
    else {
      return false;
    }
  }
}
